import { escapeHtml, formatMatchDate, points, safeUrl } from "./utils.js";

function committeeWebsite(profile) {
  try {
    const url = new URL(profile?.url || profile?.website || "");
    return ["http:", "https:"].includes(url.protocol) ? url.href : "";
  } catch (_) {
    return "";
  }
}

export function shell(content, context = {}) {
  const committee = context.committee || sessionStorage.getItem("comitato") || "";
  let profile = context.profile || null;
  if (!profile && committee) {
    try {
      profile = JSON.parse(sessionStorage.getItem(`committee-profile-${committee}`));
    } catch (_) {
      profile = null;
    }
  }
  const liveHref = committee ? `/live?comi=${encodeURIComponent(committee)}` : "/";
  const groupsHref = committee ? `/comitati/${encodeURIComponent(committee)}/campionati` : "/";
  const committeeName = profile?.nome || profile?.title || "";
  const website = committeeWebsite(profile);
  const brandHref = website || "/";
  return `
    <header class="site-header">
      <div class="container header-inner">
        <div class="site-identity${committee ? " has-committee" : ""}"${committee ? ` data-committee="${escapeHtml(committee)}"` : ""}>
          <a class="brand" href="${escapeHtml(brandHref)}"${website ? "" : " data-link"}${committee && !profile ? " hidden" : ""} aria-label="${website ? `Vai al sito ${escapeHtml(committeeName)}` : (committeeName ? `Logo ${escapeHtml(committeeName)}` : "FIPAV Online - Home")}">
            <img id="header-brand-image"${profile?.image ? ` src="${safeUrl(profile.image)}"` : (committee ? "" : ' src="/legacy/images/mpsLogo.png"')} alt="${committeeName ? `Logo ${escapeHtml(committeeName)}` : "FIPAV Online"}">
          </a>
          ${committee ? `<div class="committee-header-summary" id="committee-header-summary">
            <strong>${escapeHtml(committeeName || `Comitato ${committee}`)}</strong>
            ${profile?.indirizzo ? `<span class="committee-address">${escapeHtml(profile.indirizzo)}</span>` : ""}
            ${(profile?.tel_fax || profile?.e_mail) ? `<span class="committee-contacts">${profile?.tel_fax ? `<span class="committee-phone">${escapeHtml(profile.tel_fax)}</span>` : ""}${profile?.e_mail ? `<span class="committee-email">${escapeHtml(profile.e_mail)}</span>` : ""}</span>` : ""}
          </div>` : ""}
        </div>
        <button class="nav-toggle" type="button" aria-expanded="false" aria-controls="main-nav">Menu</button>
        <nav id="main-nav" class="main-nav" aria-label="Navigazione principale">
          <a href="/" data-link>Comitati</a>
          <a href="${liveHref}" data-link>Gare di oggi</a>
          <a href="${groupsHref}" data-link>Campionati</a>
          <a href="https://corsi.fipavonline.it">Corsi allenatori</a>
          <a class="login" href="https://fipavonline.it/login/">Login</a>
        </nav>
      </div>
    </header>
    <main id="main-content">${content}</main>
    <footer class="site-footer">
      <div class="container">
        <p class="site-copyright">© Copyright Manufacturing Point Software s.r.l. PIVA: 02888940786 - tutti i diritti riservati - <strong><a href="https://fipavonline.it/infoPrivacy.html">Privacy &amp; Cookie</a></strong></p>
        <p>Manufacturing Point software e la Federazione Italiana Pallavolo si impegnano attivamente a proteggere i propri dati dall'accesso non autorizzato attraverso il web scraping.</p>
        <p>Qualsiasi tentativo di acquisire informazioni senza autorizzazione sarà considerato una violazione delle politiche di tutela dei dati e dei dati personali e sarà perseguito legalmente.</p>
      </div>
    </footer>
    <dialog class="escore-dialog" id="escore-dialog" aria-labelledby="escore-dialog-title">
      <div class="escore-dialog-header">
        <div>
          <h2 id="escore-dialog-title">eScoreVolley</h2>
          <p id="escore-dialog-stadium"></p>
        </div>
        <button class="escore-dialog-close" type="button" aria-label="Chiudi eScoreVolley">×</button>
      </div>
      <iframe id="escore-dialog-frame" title="Diretta eScoreVolley" src="about:blank"></iframe>
      <div class="escore-dialog-footer"><button class="button secondary escore-dialog-close" type="button">Chiudi</button></div>
    </dialog>
    <dialog class="escore-dialog poster-dialog" id="poster-dialog" aria-labelledby="poster-dialog-title">
      <div class="escore-dialog-header"><h2 id="poster-dialog-title">Locandina gara</h2>
        <button class="escore-dialog-close poster-close" type="button" aria-label="Chiudi locandina">×</button>
      </div>
      <div class="poster-body"><p id="poster-error" role="status" hidden>Locandina non disponibile. Riprova tra poco.</p>
        <img id="poster-image" alt="Locandina della gara"></div>
      <div class="escore-dialog-footer"><a class="button secondary" id="poster-open" target="_blank" rel="noopener">Apri immagine</a><button class="button secondary poster-close" type="button">Chiudi</button></div>
    </dialog>`;
}

export function pageHeading(title, subtitle = "", backHref = "") {
  return `<section class="page-heading"><div class="container">
    ${backHref ? `<a class="back-link" href="${backHref}" data-link>← Indietro</a>` : ""}
    <h1>${escapeHtml(title)}</h1>${subtitle ? `<p>${escapeHtml(subtitle)}</p>` : ""}
  </div></section>`;
}

export async function hydrateCommitteeIdentity(api, committee, signal) {
  if (!committee) return;
  try {
    const profile = await api.committeeProfile(committee, signal);
    if (signal?.aborted) return;
    if (!profile) return;
    sessionStorage.setItem(`committee-profile-${committee}`, JSON.stringify(profile));
    const name = profile.nome || profile.title || `Comitato ${committee}`;
    const identity = document.querySelector(`.site-identity[data-committee="${committee}"]`);
    const image = identity?.querySelector("#header-brand-image");
    const brand = image?.closest(".brand");
    const summary = identity?.querySelector("#committee-header-summary");
    if (image && brand) {
      const logoUrl = safeUrl(profile.image);
      const logo = new Image();
      logo.src = logoUrl;
      try {
        await logo.decode();
      } catch (_) {
        // Alcuni browser non supportano decode() per tutti i formati legacy.
      }
      if (signal?.aborted || !identity.isConnected || identity.dataset.committee !== String(committee)) return;
      image.src = logoUrl;
      image.alt = `Logo ${name}`;
      brand.hidden = false;
      const website = committeeWebsite(profile);
      brand.href = website || "/";
      brand.setAttribute("aria-label", website ? `Vai al sito ${name}` : `Logo ${name}`);
      if (website) brand.removeAttribute("data-link");
      else brand.setAttribute("data-link", "");
    }
    if (summary) {
      const title = document.createElement("strong");
      title.textContent = name;
      summary.replaceChildren(title);
      if (profile.indirizzo) {
        const address = document.createElement("span");
        address.className = "committee-address";
        address.textContent = profile.indirizzo;
        summary.append(address);
      }
      if (profile.tel_fax || profile.e_mail) {
        const details = document.createElement("span");
        details.className = "committee-contacts";
        if (profile.tel_fax) {
          const phone = document.createElement("span");
          phone.className = "committee-phone";
          phone.textContent = profile.tel_fax;
          details.append(phone);
        }
        if (profile.e_mail) {
          const email = document.createElement("span");
          email.className = "committee-email";
          email.textContent = profile.e_mail;
          details.append(email);
        }
        summary.append(details);
      }
    }
  } catch (error) {
    if (error?.name !== "AbortError") console.warn("Logo comitato non disponibile", error);
  }
}

export function statusPanel(message, kind = "loading") {
  return `<div class="container"><div class="status-panel ${kind}" role="${kind === "error" ? "alert" : "status"}">${escapeHtml(message)}</div></div>`;
}

export function championshipActions(group, { current = "" } = {}) {
  const path = `/gironi/${escapeHtml(encodeURIComponent(group))}`;
  return `<div class="section-actions"><a class="compact-action" href="${path}" data-link${current === "calendar" ? ' aria-current="page"' : ""}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 11h18M8 15h2M14 15h2"/></svg><span>Calendario</span></a><a class="compact-action" href="${path}/classifica" data-link${current === "standings" ? ' aria-current="page"' : ""}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20V10h5v10M9 20V4h6v16M15 20v-7h5v7M3 20h18"/></svg><span>Classifica</span></a></div>`;
}

export function championshipHeading(group, title, subtitle, current) {
  return `<div class="section-title"><div>${subtitle ? `<small>${escapeHtml(subtitle)}</small>` : ""}<h2>${escapeHtml(title)}</h2></div>${championshipActions(group, { current })}</div>`;
}

export function matchCard(match, championshipTitle = "", { showDay = true, poster = "" } = {}) {
  const scoreA = Number(match["team1-setwin"] || 0);
  const scoreB = Number(match["team2-setwin"] || 0);
  const score = !match.played && scoreA === 0 && scoreB === 0 ? "–" : `${scoreA}–${scoreB}`;
  const isLive = Number(match.is_live) === 1;
  const isEscore = Number(match.escorevolley) === 1;
  const live = isLive || isEscore;
  const setScores = points(match);
  const referees = [match["1referee"], match["2referee"]].filter(Boolean).join(" · ");
  const escoreButton = isEscore ? `<button class="escore-button" type="button" aria-label="Apri la diretta eScoreVolley della gara ${escapeHtml(match.ng || "")}" data-escore-match="${escapeHtml(match.id)}" data-escore-title="${escapeHtml(championshipTitle || match.day || "Gara")} - Gara n. ${escapeHtml(match.ng || "")}" data-escore-stadium="${escapeHtml(match.stadium || "")}"><span class="escore-dot" aria-hidden="true"></span><span>eScoreVolley</span><span class="escore-arrow" aria-hidden="true">↗</span></button>` : "";
  return `<article class="match-card">
    <div class="match-meta">
      <div class="match-facts">
        ${showDay && match.day ? `<strong>${escapeHtml(match.day)}</strong>` : ""}
        <span>${escapeHtml(formatMatchDate(match.date))} · ${escapeHtml(match.time || "")}</span>
        <span>Gara ${escapeHtml(match.ng || "")}</span>
      </div>
      <div class="match-venue"><strong>Impianto</strong><span>${escapeHtml(match.stadium || "Sede da definire")}</span></div>
    </div>
    <div class="match-teams">
      <div class="team"><img src="${safeUrl(match.team1?.logo)}" alt="" loading="lazy"><span>${escapeHtml(match.team1?.title || "")}</span></div>
      <div class="score ${live ? "is-live" : ""}">
        ${!isEscore && isLive ? '<span class="live-label">LIVE</span>' : ""}
        <strong>${score}</strong>
        ${setScores ? `<span class="set-scores"><span class="sr-only">Parziali: </span>${setScores}</span>` : ""}
      </div>
      <div class="team team-away"><img src="${safeUrl(match.team2?.logo)}" alt="" loading="lazy"><span>${escapeHtml(match.team2?.title || "")}</span></div>
    </div>
    <div class="match-details">${escoreButton}${poster ? `<button class="button secondary poster-button" type="button" aria-label="Visualizza locandina della gara ${escapeHtml(match.ng || "")}" data-poster-url="${escapeHtml(poster)}" data-poster-title="${escapeHtml(championshipTitle)} - Gara ${escapeHtml(match.ng || "")}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z"/><path d="M14 3v6h6M8 13h8M8 17h5"/></svg><span>Locandina</span></button>` : ""}<span class="match-referees"><strong>Arbitri</strong><span>${escapeHtml(referees || "Da designare")}</span></span></div>
  </article>`;
}
